import { __decorate, __metadata } from "tslib";
import { ChargeTypeEnum } from '@goparrot/common';
import { ApiExtraModels, ApiProperty, ApiPropertyOptional, refs } from '@nestjs/swagger';
import { Expose, Type } from 'class-transformer';
import { IsBoolean, IsEnum, IsNotEmptyObject, IsOptional, IsString, IsUUID, Length, ValidateNested } from 'class-validator';
import { ServiceChargeTypeEnum } from '../enum';
import { ServiceChargeExposeGroup } from '../interface';
import { ReadBaseChargeDto } from './ReadBaseChargeDto';
import { ReadFixedChargeDto } from './ReadFixedChargeDto';
import { ReadOpenChargeDto } from './ReadOpenChargeDto';
import { ReadPercentChargeDto } from './ReadPercentChargeDto';
let ReadServiceChargeDto = class ReadServiceChargeDto {
};
__decorate([
    ApiProperty({ type: () => String, description: 'Store ID', example: 'e44acc6f-2f34-552c-92d3-x4199fb44335' }),
    Expose({ groups: [ServiceChargeExposeGroup.READ] }),
    __metadata("design:type", String)
], ReadServiceChargeDto.prototype, "storeId", void 0);
__decorate([
    ApiProperty({ type: () => String, description: 'Merchant ID', example: 'e44acc6f-2f34-552c-92d3-x4133fb22445' }),
    Expose({ groups: [ServiceChargeExposeGroup.READ] }),
    __metadata("design:type", String)
], ReadServiceChargeDto.prototype, "merchantId", void 0);
__decorate([
    ApiProperty({ type: () => String, description: 'Unique ID', example: 'e33acc6f-2f34-332c-92d3-d4199fb55345' }),
    Expose({ groups: [ServiceChargeExposeGroup.READ] }),
    __metadata("design:type", String)
], ReadServiceChargeDto.prototype, "uuid", void 0);
__decorate([
    ApiProperty({ type: () => String, description: 'Service charge name', example: 'Convenience fee' }),
    IsOptional({ groups: [ServiceChargeExposeGroup.PATCH] }),
    Length(3, 50, { always: true }),
    IsString({ always: true }),
    Expose({ groups: [ServiceChargeExposeGroup.CREATE, ServiceChargeExposeGroup.READ, ServiceChargeExposeGroup.PATCH] }),
    __metadata("design:type", String)
], ReadServiceChargeDto.prototype, "name", void 0);
__decorate([
    ApiProperty({ enum: ServiceChargeTypeEnum, example: ServiceChargeTypeEnum.DELIVERY_FEE }),
    IsOptional({ groups: [ServiceChargeExposeGroup.PATCH] }),
    IsEnum(ServiceChargeTypeEnum, { always: true }),
    Expose({ groups: [ServiceChargeExposeGroup.CREATE, ServiceChargeExposeGroup.READ, ServiceChargeExposeGroup.PATCH] }),
    __metadata("design:type", String)
], ReadServiceChargeDto.prototype, "type", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, description: 'POS GUID', example: 'MXRLETGTJ22DDD77DDKK5QME' }),
    IsOptional({ always: true }),
    Length(1, 50),
    IsString({ always: true }),
    Expose({ groups: [ServiceChargeExposeGroup.CREATE, ServiceChargeExposeGroup.READ, ServiceChargeExposeGroup.PATCH] }),
    __metadata("design:type", String)
], ReadServiceChargeDto.prototype, "guid", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, description: 'Tax reference UUID', example: 'e22acc6f-2f34-112c-92d3-d4199fb55345' }),
    IsOptional({ always: true }),
    IsUUID('4'),
    Expose({ groups: [ServiceChargeExposeGroup.CREATE, ServiceChargeExposeGroup.READ, ServiceChargeExposeGroup.PATCH] }),
    __metadata("design:type", String)
], ReadServiceChargeDto.prototype, "taxUuid", void 0);
__decorate([
    ApiProperty({
        oneOf: refs(ReadFixedChargeDto, ReadPercentChargeDto, ReadOpenChargeDto),
        type: Object,
        example: { type: ChargeTypeEnum.OPEN },
        description: 'Charge type',
    }),
    Type(() => ReadBaseChargeDto, {
        keepDiscriminatorProperty: true,
        discriminator: {
            property: 'type',
            subTypes: [
                { value: ReadFixedChargeDto, name: ChargeTypeEnum.FIXED },
                { value: ReadPercentChargeDto, name: ChargeTypeEnum.PERCENT },
                { value: ReadOpenChargeDto, name: ChargeTypeEnum.OPEN },
            ],
        },
    }),
    IsOptional({ groups: [ServiceChargeExposeGroup.PATCH] }),
    IsNotEmptyObject({ nullable: false }, { always: true }),
    ValidateNested({ always: true }),
    Expose({ groups: [ServiceChargeExposeGroup.CREATE, ServiceChargeExposeGroup.READ, ServiceChargeExposeGroup.PATCH] }),
    __metadata("design:type", Object)
], ReadServiceChargeDto.prototype, "charge", void 0);
__decorate([
    ApiProperty({ type: () => Boolean, description: 'If true, will be used in order calculation', example: false, default: false }),
    IsOptional({ groups: [ServiceChargeExposeGroup.PATCH, ServiceChargeExposeGroup.CREATE] }),
    IsBoolean({ always: true }),
    Expose({ groups: [ServiceChargeExposeGroup.CREATE, ServiceChargeExposeGroup.READ, ServiceChargeExposeGroup.PATCH] }),
    __metadata("design:type", Boolean)
], ReadServiceChargeDto.prototype, "isEnabled", void 0);
ReadServiceChargeDto = __decorate([
    ApiExtraModels(ReadBaseChargeDto, ReadFixedChargeDto, ReadPercentChargeDto, ReadOpenChargeDto)
], ReadServiceChargeDto);
export { ReadServiceChargeDto };
//# sourceMappingURL=ReadServiceChargeDto.js.map